import React, { PureComponent } from "react";
import { Button } from "../Forms/Forms";
import CONSTANTS from "../../constants";

class PopUp extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {};
  }
  static defaultProps = {
    secondaryButtonLabel: "",
    primaryButtonLabel: "",
    titlePicto: {
      showTitlePicto: false,
      src: "",
      alt: "",
    },
  };

  render() {
    return (
      <div className="popup-overlay">
        <div className="popup">
          <h2 tabIndex="0">
            {this.props.titlePicto.showTitlePicto && (
              <img
                className="title-picto"
                src={this.props.titlePicto.src}
                alt={this.props.titlePicto.alt}
                width={
                  CONSTANTS.SITE_INFO.BRAND_CODE === "C" &&
                  this.props.titlePicto.width
                    ? this.props.titlePicto.width
                    : undefined
                }
              />
            )}
            {this.props.title}
          </h2>
          <div tabIndex="0" className="content">
            {this.props.content}
          </div>
          <div className="row section-form">
            {this.props.primaryButtonLabel.length !== 0 && (
              <Button onClick={this.props.handlePrimaryButton}>
                {this.props.primaryButtonLabel}
              </Button>
            )}
            {this.props.secondaryButtonLabel.length !== 0 && (
              <Button Type="border" onClick={this.props.handleSecondaryButton}>
                {this.props.secondaryButtonLabel}
              </Button>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default PopUp;
